import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  constructor(private restangular: ApiClient) {}

  getTaskById(userId: string, taskId: string): Promise<any> {
    return this.restangular.one('users', userId).one('tasks', taskId).get().toPromise();
  }
}
